import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import "../css/style.css";
import { serverUrl } from "../_constants";
import confLogo from "../img/conf_logo.png";
import { confService } from "../_services";
import onlineLogo from "../img/online.png";
import offlineLogo from "../img/offline.png";


const getDate = (time) => {
  if (!time) return "не определено";

  const time1 = time.substr(0, 10);

  return time1.split("-").reverse().join("-");

  return time1;
};

export default function ConfItem(props) {
  const { data, onEdit, onClick, isMobile = false } = props;

  return (
    <li className={isMobile?"conf-list__item-mobile":"conf-list__item"}>
      <div className="card" onClick={props.onEdit}>
        <div className="card__top" onClick={props.onEdit}>
          <img
            src={
              data.image
                ? serverUrl + data.image.replace("public", "/storage")
                : confLogo
            }
            alt=""
            className="object-fit"
          />
          {data.type == "offline" && (
            <span className="card__label"><span>
            оффлайн
            </span>
            <img style={{marginLeft:10}} src={offlineLogo} />
            </span>
          )}
          {data.type == "online" && (
            <span className="card__label">
            <span>
            онлайн
            </span>
            <img style={{marginLeft:10}} src={onlineLogo} />
            </span>
          )}
          {data.type == "hybrid" && (
            <span className="card__label">
          <span>
            оффлайн+онлайн
            </span>
            <img style={{marginLeft:10}} src={onlineLogo} />
            <img style={{marginLeft:10}} src={offlineLogo} />
            </span>
          )}
        
        </div>

        <div className="card__body">
          <p style={{ marginBottom: 10, fontSize: 18, fontWeight: 500 }}>
            {data.name}
          </p>
          <div className="layout__inf">
            <p className="layout__inf-text">
            {confService.getConfDateTimeStr(data.start_time,data.end_time)}
            </p>

            {!data.building_id && (
              <p className="layout__inf-text">Нет адреса</p>
            )}

            <p className="layout__inf-text">
              {data.hasTicket ? "Билет куплен" : "Нет билета"}
            </p>
          </div>
          <div className="layout__inf">
            <ul className="layout__inf-list">
              <a onClick={props.onEdit} className="card__link">
                <span>Посмотреть</span>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </li>
  );
}
